module.exports = __webpack_public_path__ + "img/84.657a9221.svg";